module.exports = __webpack_public_path__ + "assets/img/logo.44d397e8.svg";